import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { makeSelectShelvesSelectedLastCabinet } from 'containers/Configurator/selectors/selection';
import { makeSelectPlates } from 'containers/Configurator/selectors/pieces';
import { Color } from 'lib/modelBuilder/entities/Color';

/**
 * Direct selector to the platePanel state domain
 */

export const selectPlatePanelDomain = (state: ApplicationRootState) =>
  state.platePanel || initialState;

export const makeSelectIsVisiblePlatePanel = () =>
  createSelector(selectPlatePanelDomain, substate => substate.isVisible);

export const makeSelectIsTopPlate = () =>
  createSelector(selectPlatePanelDomain, substate => substate.topPlate);

export const makeSelectCanDeletePlate = () =>
  createSelector(
    selectPlatePanelDomain,
    makeSelectShelvesSelectedLastCabinet(),
    (substate, selectedShelves): boolean => {
      for (const shelf of selectedShelves) {
        // @ts-ignore
        if (!shelf.rack(0).plate) {
          return false;
        }
      }
      return true;
    },
  );

export const makeSelectPlateColors = () =>
  createSelector(makeSelectPlates(), plates => {
    const colors: Color[] = [];
    for (const item of plates) {
      if (item.color) colors.push(item.color);
    }
    return colors;
  });
